import { Component, effect, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { TimeControlsComponent } from '@custom-components/general/time/time-controls/time-controls.component';
import { ChartRangeOptions, DeviceModel } from '@core/models';
import { DeviceStore } from '@root/app/store/device.store';
import { TopologicalDeviceTelemetryStore } from '@root/app/store/topological-device-telemetry.store';

@Component({
  selector: 'xemex-insights-configuration',
  imports: [TimeControlsComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './configuration.component.html',
})
export class ConfigurationComponent {
  chartRangeOptions: ChartRangeOptions[] = [
    ChartRangeOptions.Day,
    ChartRangeOptions.Week,
    ChartRangeOptions.Month,
    ChartRangeOptions.Year,
    ChartRangeOptions.DayPerQuarter,
  ];

  currentChartRange = ChartRangeOptions.Month;
  onChangeTimeOption = output<ChartRangeOptions>();
  timelineChanged = output<string>();
  telemetryStore = inject(TopologicalDeviceTelemetryStore);
  deviceDetail: DeviceModel | undefined;
  readonly deviceStore = inject(DeviceStore);

  constructor() {
    effect(() => {
      this.deviceDetail = this.deviceStore.deviceDetail();
    });
    let firstEffect = true;
    effect(() => {
      this.telemetryStore.selectedDate();
      if (!firstEffect) {
        this.refreshData(); //don't do this on the first load, as the data will already be correct.
      }
      firstEffect = false;
    });
  }

  onChartRangeChanged(e: ChartRangeOptions) {
    this.telemetryStore.setRange(e);
  }

  onChangeEnergyTime(value: string) {
    this.telemetryStore.setDate(value);
  }

  private refreshData() {
    if (this.deviceDetail) {
      this.telemetryStore.getDeviceTopologicalTelemetry({
        deviceId: this.deviceDetail.deviceId,
        chartRange: this.telemetryStore.deviceChartTimeOption(),
        selectedDate: this.telemetryStore.selectedDate(),
      });
    }
  }
}
